module.exports = __webpack_public_path__ + "static/media/backArrow.365ec93d.svg";